import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import DeskDark from '../assets/images/desk_dark.mp4';
import FrameDark from '../assets/images/frame_dark.png';
import FrameLight from '../assets/images/frame_light.png';
import DeskLight from '../assets/images/desk_light.mp4';
import Macbook from '../assets/images/macbook.png';

const MacbookFrame = () => {
  const theme = useTheme();
  const myVideo = theme.palette.mode === 'dark' ? DeskDark : DeskLight;
  const myFrame = theme.palette.mode === 'dark' ? FrameDark : FrameLight;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: '2000px',
        mx: 'auto',
        aspectRatio: '1',
        overflow: 'hidden',
        mt: 2,
        mb: isMobile ? -14 : -20,
      }}
    >
      {/* Video behind everything */}
      <Box
        component="video"
        src={myVideo}
        autoPlay
        loop
        playsInline
        muted
        // controls
        sx={{
          position: 'absolute',
          top: '-2.1%',
          left: '1.7%',
          width: '96.6%',
          height: '82.5%',
          borderRadius: '8px',
          objectFit: 'contain',
          backgroundColor: 'transparent',
          zIndex: 2,
        }}
      />
      <Box
        component="img"
        src={myFrame}
        alt="Dark Frame Overlay"
        sx={{
          // position: 'absolute',
          width: '100%',
          objectFit: 'contain',
          zIndex: 1,
          pointerEvents: 'none',
          borderRadius: '8px',
        }}
      />

      {/* MacBook Frame on top with transparent screen area */}
      {/* <Box
        component="img"
        src={Macbook}
        alt="MacBook"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          zIndex: 3,
          pointerEvents: 'none',
        }}
      /> */}
    </Box>
  );
};

export default MacbookFrame;
